import { Fragment, useEffect, useState } from 'react'
import { useTranslation } from 'next-i18next'

import PanelElementContainer from '~/panels/components/PanelElementContainer'
import useGetNonRatedSession from '~/panels/hooks/useGetNonRatedSession'
import { ButtonPrimary } from '~/components/Buttons'
import { formatAsDayWithTimezone } from '~/utils/time'
import { getBrowserTimezone } from '~/utils/helpers'
import { useModifySessionMutation } from '~/redux/apis/session-api'

import { ratingItems } from './StudentSessionRating.const'
import SessionRatingItem from './StudentSessionRatingItem'

export default function StudentSessionRating(): React.ReactElement {
  const { t } = useTranslation(['errors', 'generics', 'studentPanel'])
  const [error, setError] = useState('')
  const [modifySession, { isError }] = useModifySessionMutation()
  const timezone = getBrowserTimezone()
  const nonRatedSession = useGetNonRatedSession()

  useEffect(() => {
    if (isError) setError(t('errors:unknown'))
  }, [isError, t])

  if (!nonRatedSession) {
    return <Fragment />
  }

  const handleOnClick = async (rating: number): Promise<void> => {
    await modifySession({ id: nonRatedSession.id, studentRating: rating })
  }

  return (
    <PanelElementContainer className="space-y-8 flex flex-col items-center">
      <div className="font-semibold text-center">
        {t('studentPanel:ratingHeader', {
          name: nonRatedSession.mentor?.fullName,
          date: formatAsDayWithTimezone(new Date(nonRatedSession.startTime), timezone),
        })}
      </div>
      <div className="w-full flex justify-evenly">
        {ratingItems.map(({ emoji, i18nKey, rating }) => (
          <SessionRatingItem emoji={emoji} i18nKey={i18nKey} key={rating} onClick={handleOnClick} rating={rating} />
        ))}
      </div>
      {error && <span className="px-12 text-xxs text-center text-red">{error}</span>}
      <ButtonPrimary isWide onClick={() => handleOnClick(0)} size="small">
        {t('generics:skip')}
      </ButtonPrimary>
    </PanelElementContainer>
  )
}
